import { JoinRequestsList } from "./components/JoinRequestsList";

export function JoinRequestsPage() {
  return (
    <div className="p-4 sm:p-6">
      <JoinRequestsList />
    </div>
  );
}
